import { render, staticRenderFns } from "./DonutChart81.vue?vue&type=template&id=d57453b8&scoped=true"
import script from "./DonutChart81.vue?vue&type=script&lang=js"
export * from "./DonutChart81.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57453b8",
  null
  
)

export default component.exports